<template>
  <Layout>
    <section class="signup-wrapper">
      <div class="signup">
        <div class="header">
          <div class="logo">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
              width="86px"
              height="16px"
            />
          </div>
          <p class="header-title">PASSPORT ACCOUNT</p>
          <span class="subtitle">Register</span>
        </div>
        <b-form class="form" @submit.prevent="onSubmit" novalidate>
          <div class="row-group">
            <!-- first name  -->
            <div class="first-name-wrapper col-50">
              <div
                class="form-group m-d-gruop"
                :class="$v.form.first_name.$error && 'invalid-value'"
              >
                <b-form-input
                  id="first_name"
                  v-model.trim="form.first_name"
                  type="text"
                  required
                  class="form-control"
                  maxLength="20"
                  :class="{'cursor-not-allowed':form.first_name && form.first_name.length >= 20}"
                />
                <label for="first_name">First Name</label>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.form.first_name.required">
                  <span class="error-value">First name is required.</span>
                </div>
                <div v-else-if="submitted && !$v.form.first_name.maxLength">
                  <span class="error-value"
                    >The maximum length is 20 characters.</span
                  >
                </div>
                <div v-else-if="submitted && !$v.form.first_name.minLength">
                  <span class="error-value"
                    >The minimum length is 2 characters.</span
                  >
                </div>
              </div>
            </div>
            <!-- last name  -->
            <div class="last-name-wrapper col-50">
              <div
                class="form-group m-d-gruop"
                :class="$v.form.last_name.$error && 'invalid-value'"
              >
                <b-form-input
                  id="form.last_name"
                  v-model.trim="form.last_name"
                  maxLength="20"
                  type="text"
                  required
                  class="form-control"
                  :class="{'cursor-not-allowed':form.last_name && form.last_name.length >= 20}"
                />
                <label for="form.last_name">Last Name</label>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.form.last_name.required">
                  <span class="error-value">Last name is required.</span>
                </div>
                <div v-else-if="submitted && !$v.form.last_name.maxLength">
                  <span class="error-value"
                    >The maximum length is 20 characters.</span
                  >
                </div>
                <div v-else-if="submitted && !$v.form.last_name.minLength">
                  <span class="error-value"
                    >The minimum length is 2 characters.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <hr class="h-line" />
          <p class="hint-label">Add Email Address or Phone Number</p>
          <!-- email   -->
          <div class="email-wrapper">
            <div
              class="form-group m-d-gruop"
              :class="$v.form.email.$error && 'invalid-value'"
            >
              <b-form-input
                id="email"
                v-model.trim="form.email"
                type="text"
                required
                class="form-control"
                @input="$v.form.email.$touch()"
                @keypress="onEmailTyping"
                @paste="onEmailTyping"
              />
              <label for="email">Email Address</label>
            </div>
            <div class="err-wrapper">
              <div v-if="email_typing && !$v.form.email.required">
                <span class="error-value">Email is required.</span>
              </div>
              <div v-else-if="email_typing && !$v.form.email.email">
                <span class="error-value">Please enter valid email.</span>
              </div>
              <div
                v-else-if="
                  email_typing &&
                  form.email &&
                  getEmailDuplicatedCheck &&
                  !getEmailDuplicatedCheck.available &&
                  getEmailDuplicatedCheck.msg.length == 0
                "
              >
                <span class="error-value"
                  >Email address already exists, register with a different one
                  or
                  <router-link tag="a" to="/login" class="redirect-login"
                    >LOGIN</router-link
                  ></span
                >
              </div>
              <div
                v-else-if="
                  email_typing &&
                  form.email &&
                  getEmailDuplicatedCheck &&
                  getEmailDuplicatedCheck.msg.length > 0
                "
              >
                <span class="error-value"
                  >A deactivated account with this email address already exists,
                  login to reactivate your account.
                  <router-link tag="a" to="/login" class="redirect-login"
                    >LOGIN</router-link
                  ></span
                >
              </div>
            </div>
          </div>
          <!-- phone  -->
          <div class="input-wrapper current-phone">
            <div class="row-group phone-group justify-content-start">
              <VueCountryCode
                class="country-code-input"
                :disabledFetchingCountry="false"
                @onSelect="onSelectUserCountryCode"
                :enabledCountryCode="true"
                :preferredCountries="['GB', 'US', 'CN']"
              />
              <div
                class="form-group m-d-gruop w-100 mb-0"
                :class="
                  ($v.phone_input.$error ||
                    (phoneInputTyping && !getPhoneDuplicatedCheck)) &&
                  'invalid-value'
                "
              >
                <b-form-input
                  id="phone"
                  v-model.trim="phone_input"
                  type="text"
                  required
                  @input="$v.phone_input.$touch()"
                  @keypress="onPhoneInputTyping"
                />
                <label for="phone">Phone Number</label>
              </div>
            </div>
            <div class="err-wrapper">
              <div v-if="phoneInputTyping && !$v.phone_input.required">
                <span class="error-value"
                  >Phone number or email is required</span
                >
              </div>
              <div
                v-else-if="
                  phoneInputTyping &&
                  phone_input &&
                  getPhoneDuplicatedCheck &&
                  !getPhoneDuplicatedCheck.available &&
                  getPhoneDuplicatedCheck.msg.length == 0
                "
              >
                <span class="error-value"
                  >Phone number already exists, register with a different one or
                  <router-link tag="a" to="/login" class="redirect-login"
                    >LOGIN</router-link
                  ></span
                >
              </div>
              <div
                v-else-if="
                  phoneInputTyping &&
                  phone_input &&
                  getPhoneDuplicatedCheck &&
                  getPhoneDuplicatedCheck.msg.length > 0
                "
              >
                <span class="error-value"
                  >A deactivated account with this phone number already exists,
                  login to reactivate your account.
                  <router-link tag="a" to="/login" class="redirect-login"
                    >LOGIN</router-link
                  ></span
                >
              </div>
              <div v-else-if="submitted && !$v.phone_input.numeric">
                <span class="error-value">
                  Phone number should contain only digits.
                </span>
              </div>
            </div>
          </div>
          <button
            :disabled="
              getLoadingSubmitStatus || disableSubmitBtn || hasAnyValidationErr
            "
            type="submit"
            class="btn btn-primary btn-block submit-btn"
          >
            <i
              v-if="getLoadingSubmitStatus"
              class="
                bx bx-loader bx-spin
                font-size-16
                align-middle
                mr-2
                rounded
              "
            ></i>
            <span v-else>REGISTER</span>
          </button>
          <!-- login if has acc  -->
          <div class="login-wrapper">
            <p class="login-title">Already have an account?</p>
            <router-link tag="a" to="/login" class="login-redirect"
              >LOGIN</router-link
            >
          </div>
        </b-form>
      </div>
    </section>
  </Layout>
</template>
<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import {
  required,
  email,
  numeric,
  requiredIf,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";
import VueCountryCode from "vue-country-code";
import { mapActions, mapGetters } from "vuex";

export default {
  page: {
    title: "SignupSelector",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    VueCountryCode,
  },
  data() {
    return {
      form: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
      },
      phoneInputTyping: false,
      phone_input: null,
      userCountryCode: null,
      submitted: false,
      email_typing: false,
    };
  },
  validations: {
    form: {
      first_name: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(2),
      },
      last_name: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(2),
      },
      email: {
        required: requiredIf(function () {
          const { phone_input } = this;
          return !phone_input;
        }),
        email,
      },
    },
    phone_input: {
      required: requiredIf(function () {
        const {
          form: { email },
        } = this;
        return !email;
      }),
      numeric,
    },
  },
  watch: {
    phone_input(phone_input) {
      if (phone_input && phone_input.length > 0) {
        this.form.phone = `${this.userCountryCode}${phone_input}`;
        this.phoneInputTyping = true;
        setTimeout(() => {
          this.checkDuplicated({
            field: "phone",
            value: `${this.userCountryCode}${phone_input}`,
          });
        }, 500);
      } else {
        this.form.phone = null;
      }
    },
    "form.email"(email) {
      if (email && email.length > 0) {
        this.email_typing = true;
        setTimeout(() => {
          this.checkDuplicated({
            field: "email",
            value: email,
          });
        }, 500);
      }
    },
  },
  computed: {
    ...mapGetters("authfack", [
      "getPhoneDuplicatedCheck",
      "getLoadingSubmitStatus",
      "getEmailDuplicatedCheck",
    ]),
    disableSubmitBtn() {
      const { first_name, last_name, email, phone } = this.form;
      return !(first_name && last_name && (email || phone));
    },
    hasAnyValidationErr() {
      return (this.form.email &&
      this.getEmailDuplicatedCheck &&
      !this.getEmailDuplicatedCheck.available
        ? true
        : false) ||
        (this.form.phone &&
          this.getPhoneDuplicatedCheck &&
          !this.getPhoneDuplicatedCheck.available)
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions("authfack", [
      "resetLoading",
      "passportRegisteration",
      "resetLoading",
      "checkDuplicated",
    ]),
    onEmailTyping() {
      return (this.email_typing = true);
    },
    onSubmit() {
      const { passportRegisteration, form } = this;
      this.submitted = true;
      this.$v.form.$touch();
      if (!this.$v.$anyError) {
        passportRegisteration(form);
      }
    },
    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
    },
    onPhoneInputTyping() {
      return (this.phoneInputTyping = true);
    },
  },
  beforeMount() {
    this.resetLoading();
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 992px){
  .logo{
    width:116px!important;
    height: 22px!important;
   img{
  width:116px!important;
  height: 22px!important;
}
}
}
.signup-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  .cursor-not-allowed{
    cursor: not-allowed;
  }
  .signup {
    width: 491px;
    border-radius: 26px;
    background-color: #fff;
    padding: 50px 40px;
    .header {
      text-align: center;
      margin-bottom: 20px;
      .logo {
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 20px;
      }
      .header-title {
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        color: #000000;
        margin-bottom: 9px;
      }
      .subtitle {
        font-weight: bold;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.28);
      }
    }
    .form {
      .hint-label {
        font-weight: normal;
        font-size: 14px;
        padding-left: 21px;
        color: rgba(0, 0, 0, 0.6);
        margin: 14px 0 16px 0;
      }
      .submit-btn {
        border-radius: 22px;
        height: 44px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.87);
        font-size: 16px;
        margin-top: 44px;
        margin-bottom: 33px;
      }
      .login-wrapper {
        text-align: center;
        .login-title {
          color: rgba(0, 0, 0, 0.28);
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 22px;
        }
        .login-redirect {
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          text-transform: uppercase;
          color: #103f5e;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
